/* eslint-disable no-console */

import { Config } from './index';

const partial = (func: Function, ...defaultArgs: any[]) => (...args: any[]) =>
    func(...defaultArgs, ...args);

export function isEnabled(config: Config, name: string) {
    if (typeof config.enable[name] === 'undefined') {
        console.log(`Missing enable flag ${name}`);
    }

    if (typeof config.enable[name] === 'undefined') {
        return false;
    }

    return config.enable[name];
}

export function getUrl(config: Config, name: string) {
    return config.url[name];
}

export function getSwitchUrl(config: Config) {
    return config.domain && config.domain.switchUrl ? config.domain.switchUrl : null;
}

export function getSwitchUrlCountries(config: Config) {
    const switchUrl = getSwitchUrl(config);

    return switchUrl && switchUrl.countries ? switchUrl.countries : null;
}

export function getCountryCode(config: Config) {
    return config.countryCode;
}

export type ConfigAccessors = {
    getUrl: (name: string) => string;
    isEnabled: (name: string) => boolean;
};

export const injectAccessors = <T>(config: T): T & ConfigAccessors =>
    Object.assign(config, {
        isEnabled: partial(isEnabled, config),
        getUrl: partial(getUrl, config),
        getSwitchUrl: partial(getSwitchUrl, config),
        getCountryCode: partial(getCountryCode, config),
    });
